<div (click)="toggle()" style="margin-bottom: 2.5%; margin-top: 2.5%;" class="is-flex flex-one has-flex-content-space-between remax-checkbox form-group has-flex-align-center" [formGroup]="parentFormGroup">
  <input [id]="inputId" type="checkbox" style="display: none;" [formControl]="formControl" [attr.aria-labelledby]="'checkbox-label' + inputId"/>
  <div class="checkbox" [class.inverted]="inverted" [class.checked]="val" (keydown.enter)="toggle()" role="checkbox" tabindex="0" [attr.aria-label]="text" [aria-checked]="val">
    <svg width="22px" height="22px" version="1.1" viewBox="0 0 22 22" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <defs>
      <rect id="a" width="22" height="22" rx="2"/>
      <filter id="b" x="-2.3%" y="-2.3%" width="104.5%" height="104.5%">
      <feGaussianBlur in="SourceAlpha" result="shadowBlurInner1" stdDeviation="0.5"/>
      <feOffset dx="0" dy="0" in="shadowBlurInner1" result="shadowOffsetInner1"/>
      <feComposite in="shadowOffsetInner1" in2="SourceAlpha" k2="-1" k3="1" operator="arithmetic" result="shadowInnerInner1"/>
      <feColorMatrix in="shadowInnerInner1" values="0 0 0 0 0.768627451   0 0 0 0 0.776470588   0 0 0 0 0.784313725  0 0 0 1 0"/>
      </filter>
      </defs>
      <g [class.hidden]="val">
        <g transform="translate(-14 -705)" fill="none" fill-rule="evenodd">
        <g transform="translate(10 631)">
        <g transform="translate(4 74)">
        <use fill="#FFFFFF" fill-rule="evenodd" xlink:href="#a"/>
        <use fill="black" filter="url(#b)" xlink:href="#a"/>
        <rect x=".5" y=".5" width="21" height="21" rx="2" stroke="#007DC3"/>
        </g>
        </g>
        </g>
      </g>
      <g  [class.hidden]="!val">
        <g transform="translate(-10 -405)" fill="none" fill-rule="evenodd">
        <g transform="translate(10 405)">
        <use fill="#0078BD" fill-rule="evenodd" xlink:href="#a"/>
        <use fill="black" filter="url(#b)" xlink:href="#a"/>
        <rect x=".5" y=".5" width="21" height="21" rx="2" stroke="#007DC3"/>
        <path d="m15.156 7.3128l-6.4898 6.4097-1.7692-2.0211c-0.39339-0.45185-1.0784-0.49661-1.5281-0.1025s-0.49516 1.0777-0.10178 1.5274l2.5263 2.8872c0.19705 0.2252 0.47712 0.35874 0.77522 0.36957 0.013714 7.218e-4 0.026707 7.218e-4 0.0397 7.218e-4 0.28439 0 0.55796-0.11188 0.76079-0.31254l7.3083-7.2181c0.42587-0.42009 0.42948-1.1058 0.0093835-1.531-0.42009-0.42659-1.1051-0.42948-1.531-0.0093835" fill="#fff" fill-rule="evenodd"/>
        </g>
        </g>
      </g>
    </svg>
  </div>
  <div class="text" [class.active]="val && !disabledActiveText">
    <span class="text" *ngIf="text" [id]="inputId">{{ text }}</span>
    <span class="text" *ngIf="!text">
      <ng-content></ng-content>
    </span>
  </div>
</div>
